// ── Sentry MUST be initialized before all other imports ──
import './sentry'

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider, createRouter } from '@tanstack/react-router'

// Import the generated route tree
import { routeTree } from './routeTree.gen'
import { AuthProvider } from './lib/auth'
import { SentryErrorBoundary } from './components/SentryErrorBoundary'

import './index.css'

const router = createRouter({ routeTree })

const rootElement = document.getElementById('root')!
if (!rootElement.innerHTML) {
  const root = createRoot(rootElement)
  root.render(
    <StrictMode>
      <SentryErrorBoundary>
        <AuthProvider>
          <RouterProvider router={router} />
        </AuthProvider>
      </SentryErrorBoundary>
    </StrictMode>,
  )
}
